import React from "react";
import { Reveal } from "./Reveal";
import { ShieldCheckIcon } from "lucide-react";
export function Guarantee() {
  return <section className="w-full bg-[#fbf5f0] px-5 py-14" data-id="element-96" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto max-w-xl" data-id="element-97" data-mp="2236c2399wlx0">
        <Reveal data-id="element-98" data-mp="222wh019dfokg">
          <div className="rounded-3xl border border-[#e7d3d8] bg-white p-7 text-center sm:p-9" data-id="element-99" data-mp="221byxb48ty3h">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#f0e0e4]" data-id="element-100" data-mp="1x54trkjo8qml">
              <ShieldCheckIcon className="h-8 w-8 text-[#a04a63]" data-id="element-101" data-mp="19cefv5s7jx9o" />
            </div>
            <h2 className="font-serif-display text-2xl font-semibold text-[#3d2b30]" data-id="element-102" data-mp="14hh77zyubpxb">
              🛡️ Garantía de 7 días
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-[#6b565b] sm:text-base" data-id="element-103" data-mp="1ee3qikbiq8x8">
              Queremos que pruebes el Kit con total tranquilidad. Si durante los próximos 7 días
              sientes que el contenido no era lo que esperabas, solo escríbenos.
            </p>
            <p className="mt-4 font-serif-display text-lg font-semibold italic text-[#a04a63]" data-id="element-104" data-mp="lnby7xxkq4f6">
              Te devolveremos el 100% de tu dinero.
            </p>
            <p className="mt-2 text-sm text-[#6b565b]" data-id="element-105" data-mp="tx1p4novge3h">
              Sin preguntas. Sin complicaciones. El riesgo es completamente nuestro.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}